import React from "react";

import { useIntl } from "react-intl";

import CurrentPlan from "@mapmycustomers/shared/types/plans/CurrentPlan";
import Price from "@mapmycustomers/shared/types/plans/Price";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import TextWithInfo from "@app/component/typography/TextWithInfo";

import formatPrice from "../../util/formatPrice";
import { DescriptionColumn, PriceColumn, Row } from "../BaseRow";

interface Props {
  currentPlan: CurrentPlan;
  daysInCurrentBillingCycle: number;
  price: Price;
  remainingDays: number;
  selectedTier: Tier;
  switchingToAnnual: boolean;
}

const AdjustedPriceRow: React.FC<Props> = ({
  currentPlan,
  daysInCurrentBillingCycle,
  price,
  remainingDays,
  selectedTier,
  switchingToAnnual,
}) => {
  const intl = useIntl();
  return (
    <Row>
      <DescriptionColumn
        description={intl.formatMessage(
          {
            id: "billing.summary.adjusted.description",
            defaultMessage:
              "{count} {count, plural, one {license} other {licenses}} × {switchingToAnnual, select, true {{currentPlanPrice}} other {{selectedTierPrice} - {currentPlanPrice}}} × ({remainingDays} / {daysInCurrentBillingCycle})",
            description: "Adjusted price summary row description on Billing page",
          },
          {
            count: currentPlan.licenses,
            currentPlanPrice: formatPrice(intl, currentPlan.tier.price),
            daysInCurrentBillingCycle,
            remainingDays,
            selectedTierPrice: formatPrice(intl, selectedTier.price),
            switchingToAnnual: switchingToAnnual,
          }
        )}
        title={
          <TextWithInfo
            info={intl.formatMessage({
              id: "billing.summary.adjusted.title.hint",
              defaultMessage:
                "Adjusted Total is the credit or charge due to the difference between your plan price before and after changing your subscription.",
              description: "Hint for adjusted price summary row on Billing page",
            })}
          >
            {intl.formatMessage({
              id: "billing.summary.adjusted.title",
              defaultMessage: "Adjusted Total for Existing Users",
              description: "Adjusted price summary row on Billing page",
            })}
          </TextWithInfo>
        }
      />
      <PriceColumn>{formatPrice(intl, price, 2)}</PriceColumn>
    </Row>
  );
};

export default AdjustedPriceRow;
